import { Alert, styled, css } from '@mui/material'

import { hubloTheme, customCommonColors } from '@front/theme'

import type { Severity, Size } from './Alert'

const severityColors: Record<string, { color: string; bgColor: string }> = {
  success: {
    color: customCommonColors.green15,
    bgColor: customCommonColors.green0,
  },
  warning: {
    color: customCommonColors.yellow15,
    bgColor: customCommonColors.yellow0,
  },
  error: {
    color: customCommonColors.red15,
    bgColor: customCommonColors.red0,
  },
  info: {
    color: customCommonColors.blue15,
    bgColor: customCommonColors.blue0,
  },
}

const mediaQueryOverSm = hubloTheme.breakpoints.up('sm')

export const StyledAlert = styled(Alert)<{ severity: Severity; size: Size }>`
  &.MuiAlert-root {
    padding: 0;
    min-height: ${({ size }) => (size === 'xs' ? 'unset' : '48px')};
    ${({ size }) =>
      size === 'xs' &&
      css`
        height: 28px;
      `};
    display: flex;
    align-items: center;
    border-radius: 8px;

    ${({ size, severity }) => css`
      background-color: ${severityColors[severity].bgColor};
      border: ${size === 'xs'
        ? 'unset'
        : `1px solid ${severityColors[severity].color}`};

      .MuiAlert-icon {
        color: ${severityColors[severity].color};
        margin-right: ${hubloTheme.spacing(2)};
        margin-left: ${hubloTheme.spacing(2)};
      }
    `}
  }

  .MuiAlert-message {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: ${({ size }) => (size === 'xs' ? 'center' : 'flex-start')};
    color: ${({ size, severity }) =>
      size === 'xs'
        ? severityColors[severity].color
        : customCommonColors.black};
    font-size: ${({ size }) =>
      size === 'xs' ? '12px' : size === 'small' ? '14px' : '16px'};
    line-height: ${({ size }) =>
      size === 'xs' ? '20px' : size === 'small' ? '22px' : '24px'};
    overflow-wrap: anywhere;
    margin: ${hubloTheme.spacing(1, 0)};
    padding-right: ${hubloTheme.spacing(2)};
    margin: 0;
    flex-direction: column;
    align-items: flex-start;
    ${({ size }) =>
      size === 'xs' &&
      css`
        text-align: center;
        justify-content: center;
        align-items: center;
      `}
  }

  .MuiTypography-root {
    font-size: ${({ size }) => (size === 'small' ? '14px' : '16px')};
    line-height: ${({ size }) =>
      size === 'xs' ? '20px' : size === 'small' ? '22px' : '24px'};
  }
`

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
`

export const ChildrenWrapper = styled('div')`
  font-size: 14px;
`

export const Actions = styled('div')`
  ${mediaQueryOverSm} {
    margin-right: ${hubloTheme.spacing(2)};
  }
`
